export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state("signupDone", {
      parent: "loginModule",
      url: "/signupDone?identified&protectbuy",

      templateProvider: ["$q", ($q) => {
        return $q((resolve) => {
          // lazy load the view
          require.ensure([], () => resolve(require("./eaSignupDonePage/eaSignupDonePageModule.html")));
        });
      }],
      controller: "eaSignupDonePageModuleController",
      controllerAs: "$ctrl",
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad) => {
          //console.log("resolve module login ", $ocLazyLoad);
          return $q((resolve) => {
            require.ensure([], () => {
              let module = require("./index.js");
              // console.log(module.default);
              $ocLazyLoad.load({ name: module.default });
              resolve();
            });
          });
        }]
      }
    });
}];



// WEBPACK FOOTER //
// ./src/ui/modules/eaLoginMain/eaSignupDone/routes.js